<template>
	<CRow>
		<CCol col="12">
			<CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>{{ err_msg }} </CAlert>
			<CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>User Review Tags</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
							</div>
						</CCol>
					</div>
				</CCardHeader>
				<CCardBody>
					<v-server-table :key="tableKey" :url="module.api.otherList" :columns="columns" :options="options"
						ref="myTable" :data="data" @loaded="onDataLoaded">
						<template #actions="data">
							<CButton color="success" v-c-tooltip="$lang.buttons.general.crud.move"
								v-on:click="movePopup(data.row.id,data.row.title)" v-if="checkPermission('other-review-tag')">
								<i class="fas fa-arrows-alt"></i>
							</CButton>
							<CButton color="danger" v-c-tooltip="$lang.buttons.general.crud.delete"
								v-on:click="deletePopup(data.row.id)" v-if="checkPermission('delete-review-tag')">
								<i class="fas fa-trash"></i>
							</CButton>
						</template>
					</v-server-table>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { ReviewTag } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";
import store from "@/store/store";
import required_span from "../../components/layouts/general/required-span";
import { minLength, required } from "vuelidate/lib/validators";
import { Maxlength } from "../../store/maxlength";
Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
	name: "ReviewTag",
	mixins: [Mixin],
	components: {
		VueJsonToCsv,
		required_span,
	},
	data() {
		return {
			messageColor: "success",
			messageColorModal: "danger",
			err_msg: "",
			alertMessage: "",
			showAlert: false,
			dismissCountDownModal: 0,
			dismissCountDown: 0,
			dismissCountDownS: 0,
			self: this,
			activePage: 1,
			submitType: "",
			module: ReviewTag,
			json_data: [],
			json_label: {},
			json_title: "",
			tableKey: 0, // Add a key to force table reload
			data: [],
			largeModal: false,
			submitted: false,
			editId: "",
			reviewTag: {
				id: "",
				title: ""
			},
			maxlength: {
				title: Maxlength.tags.title,
			},
			columns: [
				this.$lang.reviewTag.table.columns.title,
				this.$lang.reviewTag.table.columns.actions,
			],
			options: {
				headings: {
					title: this.$lang.reviewTag.table.title,
					actions: this.$lang.reviewTag.table.actions,
				},
				sortable: [this.$lang.reviewTag.table.createdAt, this.$lang.reviewTag.table.isActive],
				filterable: [this.$lang.reviewTag.table.createdAt],
				perPage: 50,
			},
		};
	},
	mounted() {
		let self = this;
		store.commit("showLoader", false);
		self.dismissCountDown = 0;
		self.dismissCountDownS = 0;
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
	methods: {
		NewSkillList(item, index) {
			this.$router.push({ path: `review-tag/other` });
		},
		setAlert(value) {
			this.showAlert = value;
		},
		pageChange(val) {
			this.$router.push({ query: { page: val } });
		},
		onDataLoaded(data) {
			// console.log("data.data.data",data.data.data);
		},
		deletePopup(item) {
			this.$swal({
				title: this.$lang.common.delete_swal.are_you,
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#e55353",
				confirmButtonText: this.$lang.common.delete_swal.yes_delete,
				cancelButtonText: this.$lang.common.delete_swal.cancel,
			}).then((result) => {
				if (result.value) {
					let self = this;
					axios
						.delete(this.deleteUrlApi(this.module, item), self)
						.then(function (response) {
							if (response.data.status === 200) {
								self.$refs.myTable.refresh();
								self.err_msg = response.data.message;
								self.messageColor = "success";
								self.dismissCountDown = 10;
							} else {
								self.$refs.myTable.refresh();
								self.alertMessage = response.data.message;
								self.messageColor = "danger";
								self.dismissCountDown = 10;
							}
						}).catch(function (error) {
							let data;
							if (error.response.data.error) {
								data = error.response.data.error.toString();
							} else {
								data = error.response.data.message;
							}
							self.$refs.myTable.refresh();
							self.err_msg = data;
							self.messageColor = "danger";
							self.dismissCountDown = 10;
						});
				}
			});
		},
        movePopup(item,title) {
			this.$swal({
				title: this.$lang.common.move_swal.are_you,
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#e55353",
				confirmButtonText: this.$lang.common.move_swal.yes_move,
				cancelButtonText: this.$lang.common.move_swal.cancel,
			}).then((result) => {
				if (result.value) {
                    setTimeout(() => {
                        let self = this;
                        const postData = {
                            is_public: 1,
                            title: title
                        };
                        axios
						.post(self.editUrlApi(self.module, item), postData)
						.then(function (response) {
							self.submitted = false; //Enable Button
							if (response.data.code === 200) {
								self.$refs.myTable.refresh();
								self.err_msg = response.data.message;
								self.messageColor = "success";
								self.dismissCountDown = 10;

							} else {
								self.err_msg = response.data.message;
								self.messageColor = "danger";
								self.dismissCountDown = 10;
							}
						}).catch(function (error) {
                            let data;
							if (error.response.data.error) {
								data = error.response.data.error.toString();
							} else {
								data = error.response.data.message;
							}
                            self.err_msg = data;
                            self.messageColor = "danger";
                            self.dismissCountDown = 10;
						});
				    }, 500);
				}
			});
		}
	},
};
</script>
